const prefix = <const T extends string>(id: T) => `CardStatements.${id}` as const
export const Statements = prefix('Statements')
export const ViewStatement = prefix('ViewStatement')
export const StatementLoaded = prefix('StatementLoaded')
